module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chart-container"
  }, [_c('apexchart', {
    attrs: {
      "type": "bar",
      "height": _vm.chartHeight,
      "options": _vm.apexOptions,
      "series": _vm.apexSeries
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04a97958","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/ClientTeusAllClientsChart.vue
// module id = 2358
// module chunks = 0